import { type SxProps } from '@mui/material/styles';

export const styles = {
  root: {
    backgroundColor: '#f7f9f9',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'hidden',
  },
  backgroundEllipse: {
    position: 'absolute',
    top: '-400px',
    left: '0',
    width: '1405px',
    height: '800px',
    background:
      'radial-gradient(ellipse at center, rgba(25, 181, 210, 0.08) 0%, rgba(25, 181, 210, 0.02) 50%, transparent 70%)',
    pointerEvents: 'none',
    zIndex: 0,
  },
  content: {
    position: 'relative',
    zIndex: 1,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
} satisfies Record<string, SxProps>;
